import { api } from "@/lib/api";

export const BuyButton = ({ url, price, testid = "buy-amazon-button", className = "", compact = false }) => {
  const handleClick = () => {
    api.post("/track/amazon-click").catch(() => {});
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={handleClick}
      className={`group relative inline-flex items-center justify-center gap-2 rounded-full bg-amazon-navy font-display font-semibold text-white shadow-lg transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-amazon-orange focus:ring-offset-2 ${
        compact ? "px-4 py-2 text-sm" : "px-7 py-3.5 text-base sm:text-lg"
      } ${className}`}
    >
      <span className="font-extrabold lowercase tracking-tight">
        a<span className="text-amazon-orange">m</span>azon
      </span>
      <span className="opacity-90">{compact ? "Compra ora" : "Compra su Amazon"}</span>
      {price && (
        <span className="rounded-full bg-amazon-orange px-2.5 py-0.5 text-xs font-bold text-amazon-navy" data-testid={`${testid}-price`}>
          {price}
        </span>
      )}
      <span className="absolute -bottom-[3px] left-1/2 h-[3px] w-0 -translate-x-1/2 rounded-full bg-amazon-orange transition-all duration-300 group-hover:w-3/4" />
    </button>
  );
};
